<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (notificationSig(); as notification) {
  <div class="notification-toast">
    <div class="notification-toast__content">
      <mat-icon class="notification-toast__icon" [svgIcon]="NotificationIcons[notification.type]" aria-hidden="true" />
      <header class="notification-toast__header" role="banner">
        <p obendy-text-bold-font>{{ notification.title }}</p>
        <p class="notification-toast__header__text">{{ textSig() }}</p>
      </header>
      <button
        class="notification-toast__close-button"
        (click)="close(notification.id)"
        mat-button
        type="button"
        color="primary"
        aria-label="Fermer la notification"
      >
        <mat-icon class="notification-toast__close-button__icon" [svgIcon]="closeIcon" aria-hidden="true" />
      </button>
    </div>

    @if (notification.date) {
      @if (notification.date | timePast | async; as pastTime) {
        <p class="notification-toast__time">
          {{ pastTime }}
        </p>
      }
    }

    @if (notification.duration && valuesSig()) {
      <mat-progress-bar class="notification-toast__progress-bar" [value]="valuesSig()" mode="determinate" />
    }
  </div>
}
